import { render, staticRenderFns } from "./TheCampaignCardSettings.vue?vue&type=template&id=05d22dce"
import script from "./TheCampaignCardSettings.vue?vue&type=script&lang=js"
export * from "./TheCampaignCardSettings.vue?vue&type=script&lang=js"
import style0 from "./TheCampaignCardSettings.vue?vue&type=style&index=0&id=05d22dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports